var _line, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrSeperatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 16,
    viewBox: "0 0 400 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 8,
    x2: 400,
    y2: 8,
    stroke: "#F5F5F5",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    transform: "translate(190)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.826 10.081C197.358 10.081 196.935 9.976 196.557 9.766C196.179 9.55 195.882 9.25 195.666 8.866C195.45 8.476 195.342 8.026 195.342 7.516C195.342 7.012 195.453 6.565 195.675 6.175C195.897 5.785 196.2 5.485 196.584 5.275C196.968 5.065 197.397 4.96 197.871 4.96C198.345 4.96 198.774 5.065 199.158 5.275C199.542 5.485 199.845 5.785 200.067 6.175C200.289 6.565 200.4 7.012 200.4 7.516C200.4 8.02 200.286 8.467 200.058 8.857C199.83 9.247 199.518 9.55 199.122 9.766C198.732 9.976 198.3 10.081 197.826 10.081ZM197.826 9.19C198.09 9.19 198.336 9.127 198.564 9.001C198.798 8.875 198.987 8.686 199.131 8.434C199.275 8.182 199.347 7.876 199.347 7.516C199.347 7.156 199.278 6.853 199.14 6.607C199.002 6.355 198.819 6.166 198.591 6.04C198.363 5.914 198.117 5.851 197.853 5.851C197.589 5.851 197.343 5.914 197.115 6.04C196.893 6.166 196.716 6.355 196.584 6.607C196.452 6.853 196.386 7.156 196.386 7.516C196.386 8.05 196.521 8.464 196.791 8.758C197.067 9.046 197.412 9.19 197.826 9.19ZM202.44 5.761C202.59 5.509 202.788 5.314 203.034 5.176C203.286 5.032 203.583 4.96 203.925 4.96V6.022H203.664C203.262 6.022 202.956 6.124 202.746 6.328C202.542 6.532 202.44 6.886 202.44 7.39V10H201.414V5.041H202.44V5.761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrSeperatorIcon);
export default __webpack_public_path__ + "static/media/orSeperatorIcon.3e1f3b149d86c937b42f333a6f62b067.svg";
export { ForwardRef as ReactComponent };